// extracted by mini-css-extract-plugin
export default {"form":"MotivoForm_form__drl96"};